import PropTypes from 'prop-types';
import React from 'react';
import { Panel } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import { SEE, AVAILABLE_SPECIALS } from '../constants/constants';
import { toggleSpecialsEvent } from '../utils/analytics';

const styles = {
	expandedIconStyle: 'collapse',
	collapsedIconStyle: 'expand'
};

class IncentiveWrapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isExpanded: false
		};
	}

	toggleExpand() {
		const { labels, incentiveCount, widgetName, windowId } = this.props;
		const title = `${labels.SEE} ${incentiveCount} ${labels.AVAILABLE_SPECIALS}`;
		const isExpanded = !this.state.isExpanded;
		toggleSpecialsEvent(widgetName, windowId, title, isExpanded);
		this.setState({
			isExpanded
		});
	}

	render() {
		const { isMobile } = this.props;
		const paddingClasses = isMobile ? 'pb-3 pt-0' : 'py-3';
		const { expandedIconStyle, collapsedIconStyle } = styles;
		const icon = this.state.isExpanded
			? expandedIconStyle
			: collapsedIconStyle;
		const panelTitle = (
			<Common
				render={({ labels }) => {
					return `${labels.get(SEE)}
						${this.props.incentiveCount}
						${labels.get(AVAILABLE_SPECIALS)}`;
				}}
			/>
		);

		const panelHeader = (
			<h4>
				<div
					className={`text-primary font-weight-bold ${paddingClasses}`}
				>
					<i
						className={`ddc-icon icon-style-collapse ddc-icon-${icon} d-inline mr-3`}
					/>
					{panelTitle}
				</div>
			</h4>
		);
		return (
			<Panel
				className="mb-0 border-0"
				onToggle={this.toggleExpand.bind(this)}
			>
				<Panel.Heading>
					<Panel.Title toggle>{panelHeader}</Panel.Title>
				</Panel.Heading>
				<Panel.Collapse>
					<Panel.Body>{this.props.children}</Panel.Body>
				</Panel.Collapse>
			</Panel>
		);
	}
}

IncentiveWrapper.propTypes = {
	incentiveCount: PropTypes.number.isRequired,
	isMobile: PropTypes.bool.isRequired,
	children: PropTypes.element.isRequired,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired,
	labels: PropTypes.shape({
		SEE: PropTypes.string.isRequired,
		AVAILABLE_SPECIALS: PropTypes.string.isRequired
	}).isRequired
};

export default IncentiveWrapper;



// WEBPACK FOOTER //
// ./src/components/IncentiveWrapper.jsx